import { BaseModel } from "./base.model";

export class CardHistoryModel extends BaseModel{
    constructor(params: Partial<CardHistoryModel> = {} as CardHistoryModel) {
        super();
        Object.assign(this, params);
    }
    auto_id?:number;
    id:any;
    datetime:any;
    cardId:any;
    userid:any;
    officeid:any;
    formReceivedId:any;
    formReceivedNo:any;
    actionName:any;
    notes:any;
    userfullname:any;
}